import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	contentSection: {
		padding: `${SPACE[12]}px ${SPACE[20]}px`,
	},
	contentHeader: {
		display: 'flex',
		gap: SPACE[8],
	},
	contentListTitle: {
		marginBottom: SPACE[24],
		marginTop: SPACE[8],
	},
	contentAddButton: {
		marginBottom: SPACE[8],
		marginLeft: 'auto',
	},
	emptyText: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
	},
	summaryText: {
		alignItems: 'center',
		color: THEME.colors.text.main,
		display: 'flex',
		flexWrap: 'wrap',
		fontSize: THEME.typography.fontSizes.sm,
		gap: SPACE[4],
		marginBottom: SPACE[8],
	},
	tableOverrides: {
		marginTop: SPACE[16],
		padding: SPACE[8],
	},
	activityCell: {
		alignItems: 'center',
		display: 'inline-flex',
		gap: SPACE[4],
	},
	activityName: {
		fontSize: THEME.typography.fontSizes.sm,
	},
	activityLink: {
		color: THEME.colors.primary.main,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		padding: 0,
	},
	clickableRow: {
		cursor: 'pointer',
		':hover': {
			background: THEME.colors.background.main,
		},
		':focus-visible': {
			outline: `2px solid ${THEME.colors.primary.main}`,
			outlineOffset: -2,
		},
	},
	detailsCell: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		paddingBottom: SPACE[8],
		paddingTop: 0,
	},
	loadMore: {
		display: 'flex',
		justifyContent: 'center',
		paddingTop: SPACE[8],
	},
});
